<!-- Head -->
<ng-template #dialogHead>
  <label class="label-title">{{data.isEdit ? 'Update Charge' : 'Create New Charge'}}</label>
  <button mat-icon-button (click)="onClose()" class="custom-mat-icon-button button-close-panel">
    <mat-icon svgIcon="ico-close" class="custom-mat-icon ico-size ico-2xs"></mat-icon>
  </button>
</ng-template>
<!-- Body -->
<ng-template #dialogBody>
  <mat-tab-group mat-align-tabs="center" class="custom-mat-tab-group" dynamicHeight>
    <mat-tab>
      <ng-template mat-tab-label>
        <span [ngClass]="{'required-fields': chargeDetailsFormErrors }">Details {{chargeDetailsFormErrors ? '*' : null}}</span>
      </ng-template>
      <form-charge-details
        [_data]=data
        (_emitBodyParams)="onGetChargeDetailsBodyParams($event)"
        (_emitFormErrors)="onGetChargeDetailsFormErrors($event)">
      </form-charge-details>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span [ngClass]="{'required-fields': chargePriceFormErrors }">Price {{chargePriceFormErrors ? '*' : null}}</span>
      </ng-template>
      <form-charge-price
      #chargePrice
        [_data]=data
        (_emitBodyParams)="onGetChargePriceBodyParams($event)"
        (_emitFormErrors)="onGetChargePriceFormErrors($event)">
      </form-charge-price>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span [ngClass]="{'required-fields': chargeScheduleFormErrors }">Schedule {{chargeScheduleFormErrors ? '*' : null}}</span>
      </ng-template>
      <form-charge-schedule
        [_data]=data
        (_emitBillCycleType)="onGetBillCycleType($event)"
        (_emitBodyParams)="onGetChargeScheduleBodyParams($event)"
        (_emitChargeType)="onGetChargeType($event)"
        (_emitFormErrors)="onGetChargeScheduleFormErrors($event)">
      </form-charge-schedule>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span [ngClass]="{'required-fields': chargeRulesFormErrors }">Rules {{(chargeRulesFormErrors) ? '*' : null}}</span>
      </ng-template>
      <form-charge-rules-component
          [_data]=data
          [_selectedChargeType]="selectedChargeType"
          [_selectedBillCycleTypeValue]="selectedBillCycleTypeValue"
          (_emitChargesRules)="onGetChargeRules($event)"
          (_emitChangeChargeRules)="chargePrice.refreshQuantityOnUsageBased()"
          (_emitFormErrors)="onGetChargeRulesFormErrors($event)">
      </form-charge-rules-component>
    </mat-tab>
  </mat-tab-group>
</ng-template>
<!-- Nav -->
<ng-template #dialogNav>
  <button mat-flat-button (click)="onSubmit()" color="primary" class="mat-button custom-mat-button-primary">{{data.isEdit ? 'Update Charge' : 'Add New Charge'}}</button>
</ng-template>

<app-dialog
  [dialogHead]="dialogHead"
  [dialogBody]="dialogBody"
  [dialogNav]="dialogNav">
</app-dialog>
